var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55 17.0625H5.7C2.4075 17.0625 0.9375 15.5925 0.9375 12.3V9.45C0.9375 6.1575 2.4075 4.6875 5.7 4.6875H7.95C8.2575 4.6875 8.5125 4.9425 8.5125 5.25C8.5125 5.5575 8.2575 5.8125 7.95 5.8125H5.7C3.015 5.8125 2.0625 6.765 2.0625 9.45V12.3C2.0625 14.985 3.015 15.9375 5.7 15.9375H8.55C11.235 15.9375 12.1875 14.985 12.1875 12.3V10.05C12.1875 9.7425 12.4425 9.4875 12.75 9.4875C13.0575 9.4875 13.3125 9.7425 13.3125 10.05V12.3C13.3125 15.5925 11.8425 17.0625 8.55 17.0625Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7512 10.6133H10.3512C8.24367 10.6133 7.38867 9.75835 7.38867 7.65085V5.25085C7.38867 5.02585 7.52367 4.81585 7.73367 4.73335C7.94367 4.64335 8.18367 4.69585 8.34867 4.85335L13.1487 9.65335C13.3062 9.81085 13.3587 10.0583 13.2687 10.2683C13.1862 10.4783 12.9762 10.6133 12.7512 10.6133ZM8.51367 6.60835V7.65085C8.51367 9.14335 8.85867 9.48835 10.3512 9.48835H11.3937L8.51367 6.60835Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7012 2.0625H8.70117C8.39367 2.0625 8.13867 1.8075 8.13867 1.5C8.13867 1.1925 8.39367 0.9375 8.70117 0.9375H11.7012C12.0087 0.9375 12.2637 1.1925 12.2637 1.5C12.2637 1.8075 12.0087 2.0625 11.7012 2.0625Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4.3125C4.9425 4.3125 4.6875 4.0575 4.6875 3.75C4.6875 2.1975 5.9475 0.9375 7.5 0.9375H9.465C9.7725 0.9375 10.0275 1.1925 10.0275 1.5C10.0275 1.8075 9.7725 2.0625 9.465 2.0625H7.5C6.57 2.0625 5.8125 2.82 5.8125 3.75C5.8125 4.0575 5.5575 4.3125 5.25 4.3125Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3906 13.3125C14.0831 13.3125 13.8281 13.0575 13.8281 12.75C13.8281 12.4425 14.0831 12.1875 14.3906 12.1875C15.2456 12.1875 15.9356 11.49 15.9356 10.6425V6C15.9356 5.6925 16.1906 5.4375 16.4981 5.4375C16.8056 5.4375 17.0606 5.6925 17.0606 6V10.6425C17.0606 12.1125 15.8606 13.3125 14.3906 13.3125Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.56335H14.25C12.255 6.56335 11.4375 5.74585 11.4375 3.75085V1.50085C11.4375 1.27585 11.5725 1.06585 11.7825 0.983346C11.9925 0.893346 12.2325 0.945846 12.3975 1.10335L16.8975 5.60335C17.055 5.76085 17.1075 6.00835 17.0175 6.21835C16.935 6.42835 16.725 6.56335 16.5 6.56335ZM12.5625 2.85835V3.75085C12.5625 5.12335 12.8775 5.43835 14.25 5.43835H15.1425L12.5625 2.85835Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/copyicon.86ee65ebf9a570d6e9f6cd18d948d9b6.svg";
export { ForwardRef as ReactComponent };